import React, { useState } from "react";
import { CiSettings } from "react-icons/ci";
import { FcSpeaker } from "react-icons/fc";
import { PiComputerTowerDuotone } from "react-icons/pi";
import { GiComputerFan } from "react-icons/gi";
import ContactUs from "./ContactUs"; // Import ContactUs component
import Modal from "../Modal";

function LearnersProfile() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const profiles = [
        {
            count: "700k+",
            description:
                "Data Scientist, Business Analyst, Machine Learning Engineer, Big Data Analyst.",
            icon: <CiSettings />,
        },
        {
            count: "200k+",
            description:
                "Digital Marketing Manager, Product Manager, Program Manager, Product Analyst.",
            icon: <FcSpeaker />,
        },
        {
            count: "300k+",
            description:
                "Project Manager, Technical Architect, Scrum Master, Project Quality Manager.",
            icon: <PiComputerTowerDuotone />,
        },
        {
            count: "800k+",
            description:
                "JAVA Developer, Testing Engineer, Automation QA DevOps Engineer, Cloud Architect.",
            icon: <GiComputerFan />,
        },
    ];

    return (
        <div className="bg-[#E4EEFC] py-16 text-center">
            <h2 className="text-3xl md:text-4xl font-bold  mb-6">
                Our Learners' Profile
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-6 md:px-20">
                {profiles.map((profile, index) => (
                    <div
                        key={index}
                        className="bg-white p-6 rounded-xl shadow-lg border border-gray-200"
                    >
                        <div className="text-4xl flex items-center justify-center mx-auto text-orange-500">{profile.icon}</div>
                        <h3 className="text-2xl font-bold text-gray-900 my-3">
                            {profile.count}
                        </h3>
                        <p className="text-gray-600">{profile.description}</p>
                    </div>
                ))}
            </div>

            <button
                onClick={openModal}
                className="mt-8 bg-blue-600 text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-blue-700 transition"
            >
                Start Hiring
            </button>

            {/* Modal */}
            {isModalOpen && (
                <Modal isOpen={isModalOpen} onClose={closeModal}>
                    <div className="flex items-center justify-content-between bg-[#0e63e2] rounded-md mb-2 py-3">
                        <p className="text-white font-bold text-xl pl-3">Contact Us</p>
                    </div>
                    <div className="bg-white w-[100%] h-[88%] rounded-lg shadow-lg relative overflow-auto">
                        <ContactUs />
                    </div>
                </Modal>
            )}

        </div>
    );
}

export default LearnersProfile;
